export enum PERMISSION_TYPES {
  SYSTEM = 'SYSTEM',
  CUSTOM = 'CUSTOM',
  VIRTUAL = 'VIRTUAL',
}

// list only common permissions here
export enum PERMISSION_ACTIONS {
  READ = 'READ',
  WRITE = 'WRITE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
}

export interface PermissionDescription {
  permission: string;
  description: string;
}

// always have the ACTION:MODULE format
// also add a relevant description to above object array in the added format
export enum SPECIAL_PERMISSION_ACTIONS {
  // Login related permissions
  AUTHORIZED_ADMIN_LOGIN = 'AUTHORIZED_ADMIN:LOGIN',
  BLOCK_LOGIN = 'BLOCK:LOGIN',

  // Identities-hierarchy related permissions
  IDENTITIES_HIERARCHY_VIEW_SELF = 'VIEW_SELF_HIERARCHY:IDENTITIES',
  IDENTITIES_HIERARCHY_VIEW_SUBORDINATES = 'VIEW_SUBORDINATES_HIERARCHY:IDENTITIES',
  IDENTITIES_HIERARCHY_VIEW_ALL = 'VIEW_ALL_HIERARCHY:IDENTITIES',
  IDENTITIES_VIEW_MODULES = 'VIEW_MODULES:IDENTITIES',

  // Identities special permissions
  IDENTITIES_RESEND_CREDENTIALS = 'RESEND_CREDENTIALS:IDENTITIES',

  // Notifications related permissions
  VIEW_ALL_NOTIFICATION = 'VIEW_ALL_NOTIFICATION',

  // Logs related permissions
  VIEW_SYSTEM_LOGS = 'VIEW_SYSTEM:LOGS',
  VIEW_ALL_LOGS = 'VIEW_ALL:LOGS',
  HIERARCHY_LOGS = 'HIERARCHY:LOGS',

  // Storage Admin permissions
  VIEW_SYSTEM_ENTITIES = 'VIEW_SYSTEM_ENTITIES:STORAGE',
  READ_ALL_ENTITIES = 'READ_ALL_ENTITIES:STORAGE',
  WRITE_ALL_ENTITIES = 'WRITE_ALL_ENTITIES:STORAGE',
  EDIT_ALL_ENTITIES = 'EDIT_ALL_ENTITIES:STORAGE',
  DELETE_ALL_ENTITIES = 'DELETE_ALL_ENTITIES:STORAGE',
  RESTORE_ALL_ENTITIES = 'RESTORE_ALL_ENTITIES:STORAGE', // TODO:@sanjeewa use this to restore files from trash
  INTERNAL_SHARE_ALL_ENTITIES = 'INTERNAL_SHARE_ALL_ENTITIES:STORAGE',
  EXTERNAL_SHARE_ALL_ENTITIES = 'EXTERNAL_SHARE_ALL_ENTITIES:STORAGE',
  PUBLIC_SHARE_ALL_ENTITIES = 'PUBLIC_SHARE_ALL_ENTITIES:STORAGE',

  // Storage quota permissions
  READ_STORAGE_QUOTA = 'READ:STORAGE_QUOTA',
  WRITE_STORAGE_QUOTA = 'WRITE:STORAGE_QUOTA',
  READ_USER_QUOTA = 'READ:USER_QUOTA',
  WRITE_USER_QUOTA = 'WRITE:USER_QUOTA',

  // Identities Public API related permissions
  IDENTITIES_INTEGRATION = 'INTEGRATION:IDENTITIES',
  READ_IDENTITIES_API_KEYS = 'READ:IDENTITIES_API_KEYS',
  EDIT_IDENTITIES_API_KEYS = 'EDIT:IDENTITIES_API_KEYS',
  WRITE_IDENTITIES_API_KEYS = 'WRITE:IDENTITIES_API_KEYS',
  DELETE_IDENTITIES_API_KEYS = 'DELETE:IDENTITIES_API_KEYS',
  RESTORE_IDENTITIES_API_KEYS = 'RESTORE:IDENTITIES_API_KEYS',

  // Storage Public API related permissions
  DRIVE_INTEGRATION = 'INTEGRATION:STORAGE_DRIVE',
  READ_STORAGE_API_KEYS = 'READ:STORAGE_API_KEYS',
  EDIT_STORAGE_API_KEYS = 'EDIT:STORAGE_API_KEYS',
  WRITE_STORAGE_API_KEYS = 'WRITE:STORAGE_API_KEYS',
  DELETE_STORAGE_API_KEYS = 'DELETE:STORAGE_API_KEYS',
  RESTORE_STORAGE_API_KEYS = 'RESTORE:STORAGE_API_KEYS',

  // Interfaces related permissions
  SYSTEM_INTEGRATION = 'INTEGRATION:SYSTEM',

  // Profile related permissions
  EDIT_PROFILE = 'EDIT:PROFILE',

  // Storage entities related permissions
  READ_ENTITIES = 'READ:ENTITIES',
  WRITE_ENTITIES = 'WRITE:ENTITIES',
  INTERNAL_SHARE_ENTITIES = 'SHARE_INTERNAL:ENTITIES',
  EXTERNAL_SHARE_ENTITIES = 'SHARE_EXTERNAL:ENTITIES',
  PUBLIC_SHARE_ENTITIES = 'SHARE_PUBLIC:ENTITIES',
  DELETE_ENTITIES = 'DELETE:ENTITIES',
  EDIT_ENTITIES = 'EDIT:ENTITIES',

  //BUSINESS FLOW
  VERIFY_DOCUMENTS = 'VERIFY_DOCUMENTS:POLICIES',
  VIEW_PROPOSAL = 'VIEW_DOCUMENTS:POLICIES',

  // Widget layout
  // Trash special permissions
  READ_TRASH_INFO = 'READ:TRASH_INFO',

  // Widgets
  READ_ALL_WIDGET_LAYOUTS = 'READ:ALL_WIDGET_LAYOUTS',
  WRITE_ALL_WIDGET_LAYOUTS = 'WRITE:ALL_WIDGET_LAYOUTS',

  // Widgets
  VIEW_ACTIVITIES = 'VIEW_ACTIVITIES',
  WIDGET_ACTIVITIES_MONTHLY_COUNT_TEAM = 'WIDGET_ACTIVITIES_MONTHLY_COUNT_TEAM',
  WIDGET_ACTIVITIES_MONTHLY_COUNT_OVERALL = 'WIDGET_ACTIVITIES_MONTHLY_COUNT_OVERALL',
  WIDGET_ACTIVITIES_WEEKLY_SCHEDULED_ACTIVITIES = 'WIDGET_ACTIVITIES_WEEKLY_SCHEDULED_ACTIVITIES',
  WIDGET_LEADS_CS_MONTHLY_OVERALL = 'WIDGET_LEADS(CS)_MONTHLY_OVERALL',
  WIDGET_LEADS_CS_MONTHLY_TEAM = 'WIDGET_LEADS(CS)_MONTHLY_TEAM',
  WIDGET_LEADS_CS_MONTHLY_SELF = 'WIDGET_LEADS(CS)_MONTHLY_SELF',
  WIDGET_LEADS_RC_MONTHLY_OVERALL = 'WIDGET_LEADS(RC)_MONTHLY_OVERALL',
  WIDGET_LEADS_RC_MONTHLY_TEAM = 'WIDGET_LEADS(RC)_MONTHLY_TEAM',
  WIDGET_LEADS_RC_MONTHLY_SELF = 'WIDGET_LEADS(RC)_MONTHLY_SELF',
  WIDGET_LEADS_MONTHLY_OVERALL = 'WIDGET_LEADS_MONTHLY_OVERALL',
  WIDGET_LEADS_MONTHLY_TEAM = 'WIDGET_LEADS_MONTHLY_TEAM',
  WIDGET_LEADS_MONTHLY_SELF = 'WIDGET_LEADS_MONTHLY_SELF',
  WIDGET_LEADS_TURNAROUND_OVERALL = 'WIDGET_LEADS_TURNAROUND_OVERALL',
  WIDGET_LEADS_TURNAROUND_TEAM = 'WIDGET_LEADS_TURNAROUND_TEAM',
  WIDGET_LEADS_TURNAROUND_SELF = 'WIDGET_LEADS_TURNAROUND_SELF',
  WIDGET_LEADS_CHANNEL_OVERALL = 'WIDGET_LEADS_CHANNEL_OVERALL',
  WIDGET_LEADS_TIME_OVERALL = 'WIDGET_LEADS_TIME_OVERALL',
  WIDGET_AGENT_TEAM = 'WIDGET_AGENT_TEAM',
  WIDGET_AGENT_OVERALL = 'WIDGET_AGENT_OVERALL',
  WIDGET_AGENT_TIME_OVERALL = 'WIDGET_AGENT_TIME_OVERALL',
  WIDGET_REC_STATUS_OVERALL = 'WIDGET_REC_STATUS_OVERALL',
  WIDGET_REC_STATUS_TEAM = 'WIDGET_REC_STATUS_TEAM',
  WIDGET_REC_STATUS_SELF = 'WIDGET_REC_STATUS_SELF',
  WIDGET_REC_SELF = 'WIDGET_REC_SELF',
  WIDGET_REC_TEAM = 'WIDGET_REC_TEAM',
  WIDGET_REC_OVERALL = 'WIDGET_REC_OVERALL',
  WIDGET_CUSTOMER_SELF = 'WIDGET_CUSTOMER_SELF',
  WIDGET_CUSTOMER_OVERALL = 'WIDGET_CUSTOMER_OVERALL',
  WIDGET_CUSTOMER_TIME_OVERALL = 'WIDGET_CUSTOMER_TIME_OVERALL',
  WIDGET_POLICIES_STATUS_OVERALL = 'WIDGET_POLICIES_STATUS_OVERALL',
  WIDGET_POLICIES_STATUS_TEAM = 'WIDGET_POLICIES_STATUS_TEAM',
  WIDGET_POLICIES_STATUS_SELF = 'WIDGET_POLICIES_STATUS_SELF',
  WIDGET_POLICIES_OVERALL = 'WIDGET_POLICIES_OVERALL',
  WIDGET_POLICIES_TEAM = 'WIDGET_POLICIES_TEAM',
  WIDGET_POLICIES_SELF = 'WIDGET_POLICIES_SELF',
  WIDGET_POLICIES_MONTHLY_OVERALL = 'WIDGET_POLICIES_MONTHLY_OVERALL',
  WIDGET_POLICIES_MONTHLY_TEAM = 'WIDGET_POLICIES_MONTHLY_TEAM',
  WIDGET_POLICIES_MONTHLY_SELF = 'WIDGET_POLICIES_MONTHLY_SELF',
  WIDGET_POLICIES_CLASS_OVERALL = 'WIDGET_POLICIES_CLASS_OVERALL',
  WIDGET_POLICIES_CLASS_TEAM = 'WIDGET_POLICIES_CLASS_TEAM',
  WIDGET_POLICIES_CLASS_SELF = 'WIDGET_POLICIES_CLASS_SELF',
  WIDGET_POLICIES_CLASS_MONTHLY_OVERALL = 'WIDGET_POLICIES_CLASS_MONTHLY_OVERALL',
  WIDGET_POLICIES_CLASS_MONTHLY_SELF = 'WIDGET_POLICIES_CLASS_MONTHLY_SELF',
  WIDGET_POLICY_TIME_OVERALL = 'WIDGET_POLICY_TIME_OVERALL',
  WIDGET_POLICIES_CLASS_MONTHLY_TEAM = 'WIDGET_POLICIES_CLASS_MONTHLY_TEAM',
  WIDGET_COVERNT_MONTHLY_COUNT_OVERALL = 'WIDGET_COVERNT_MONTHLY_COUNT_OVERALL',
  WIDGET_COVERNT_MONTHLY_COUNT_SELF = 'WIDGET_COVERNT_MONTHLY_COUNT_SELF',
  WIDGET_COVERNT_MONTHLY_STATUS_OVERALL = 'WIDGET_COVERNT_MONTHLY_STATUS_OVERALL',
  WIDGET_COVERNT_MONTHLY_STATUS_SELF = 'WIDGET_COVERNT_MONTHLY_STATUS_SELF',
  WIDGET_ENDORSEMENT_MONTHLY_COUNT_OVERALL = 'WIDGET_ENDORSEMENT_MONTHLY_COUNT_OVERALL',
  WIDGET_ENDORSEMENT_MONTHLY_COUNT_SELF = 'WIDGET_ENDORSEMENT_MONTHLY_COUNT_SELF',
  WIDGET_ENDORSEMENT_MONTHLY_STATUS_OVERALL = 'WIDGET_ENDORSEMENT_MONTHLY_STATUS_OVERALL',
  WIDGET_ENDORESEMENT_MONTHLY_STATUS_SELF = 'WIDGET_ENDORESEMENT_MONTHLY_STATUS_SELF',
  WIDGET_CLAIMS_MONTHLY_COUNT_OVERALL = 'WIDGET_CLAIMS_MONTHLY_COUNT_OVERALL',
  WIDGET_CLAIMS_MONTHLY_COUNT_TEAM = 'WIDGET_CLAIMS_MONTHLY_COUNT_TEAM',
  WIDGET_CLAIMS_MONTHLY_COUNT_SELF = 'WIDGET_CLAIMS_MONTHLY_COUNT_SELF',
  WIDGET_CLAIMS_MONTHLY_STATUS_OVERALL = 'WIDGET_CLAIMS_MONTHLY_STATUS_OVERALL',
  WIDGET_CLAIMS_MONTHLY_STATUS_TEAM = 'WIDGET_CLAIMS_MONTHLY_STATUS_TEAM',
  WIDGET_CLAIMS_MONTHLY_STATUS_SELF = 'WIDGET_CLAIMS_MONTHLY_STATUS_SELF',
  WIDGET_CLAIMS_MONTHLY_CLASS_OVERALL = 'WIDGET_CLAIMS_MONTHLY_CLASS_OVERALL',
  WIDGET_CLAIMS_MONTHLY_CLASS_TEAM = 'WIDGET_CLAIMS_MONTHLY_CLASS_TEAM',
  WIDGET_CLAIMS_MONTHLY_CLASS_SELF = 'WIDGET_CLAIMS_MONTHLY_CLASS_SELF',
  WIDGET_INVOICES_PAYMENT_COUNT_OVERALL = 'WIDGET_INVOICES_PAYMENT_COUNT_OVERALL',
  WIDGET_INVOICES_PAYMENT_COUNT_TEAM = 'WIDGET_INVOICES_PAYMENT_COUNT_TEAM',
  WIDGET_INVOICES_PAYMENT_COUNT_SELF = 'WIDGET_INVOICES_PAYMENT_COUNT_SELF',
  WIDGET_INVOICES_MONTHLY_STATUS_OVERALL = 'WIDGET_INVOICES_MONTHLY_STATUS_OVERALL',
  WIDGET_INVOICES_MONTHLY_STATUS_TEAM = 'WIDGET_INVOICES_MONTHLY_STATUS_TEAM',
  WIDGET_INVOICES_MONTHLY_STATUS_SELF = 'WIDGET_INVOICES_MONTHLY_STATUS_SELF',
  WIDGET_RECEIPTS_MONTHLY_COUNT_OVERALL = 'WIDGET_RECEIPTS_MONTHLY_COUNT_OVERALL',
  WIDGET_RECEIPTS_MONTHLY_COUNT_SELF = 'WIDGET_RECEIPTS_MONTHLY_COUNT_SELF',

  //targets widgets
  WIDGET_TARGETS_MONTHLY_TARGETS = 'WIDGET_TARGETS_MONTHLY_TARGETS',

  //achievements widgets
  WIDGET_ACHIEVEMENTS_MONTHLY_ACHIEVEMENTS = 'WIDGET_ACHIEVEMENTS_MONTHLY_ACHIEVEMENTS',
  WIDGET_ACHIEVEMENTS_INDIVIDUAL_ACHIEVEMENTS_LAST_MONTHS = 'WIDGET_ACHIEVEMENTS_INDIVIDUAL_ACHIEVEMENTS_LAST_MONTHS',
  WIDGET_ACHIEVEMENTS_TEAM_ACHIEVEMENTS_LAST_MONTHS = 'WIDGET_ACHIEVEMENTS_TEAM_ACHIEVEMENTS_LAST_MONTHS',

  //payouts widgets
  WIDGET_PAYOUTS_TOTAL_EARNINGS = 'WIDGET_PAYOUTS_TOTAL_EARNINGS',
  WIDGET_PAYOUTS_TOTAL_PAYOUTS = 'WIDGET_PAYOUTS_TOTAL_PAYOUTS',
  WIDGET_PAYOUTS_TOTAL_COMMISSIONS = 'WIDGET_PAYOUTS_TOTAL_COMMISSIONS',
  WIDGET_PAYOUTS_TOTAL_COMMISSIONS_TEAM = 'WIDGET_PAYOUTS_TOTAL_COMMISSIONS_TEAM',
  WIDGET_PAYOUTS_TOTAL_COMMISSIONS_PAYOUTS = 'WIDGET_PAYOUTS_TOTAL_COMMISSIONS_PAYOUTS',
  WIDGET_PAYOUTS_TOTAL_PAYOUTS_LAST_MONTHS = 'WIDGET_PAYOUTS_TOTAL_PAYOUTS_LAST_MONTHS',
  WIDGET_PAYOUTS_YEAR_TO_DATE_COMMISSION_EARNINGS = 'WIDGET_PAYOUTS_YEAR_TO_DATE_COMMISSION_EARNINGS',
  WIDGET_PAYOUTS_YEAR_TO_DATE_INCENTIVE_EARNINGS = 'WIDGET_PAYOUTS_YEAR_TO_DATE_INCENTIVE_EARNINGS',
  WIDGET_PAYOUTS_IN_QUEUE_COUNT = 'WIDGET_PAYOUTS_IN_QUEUE_COUNT',
  WIDGET_PAYOUTS_PENDING_APPROVAL_COUNT = 'WIDGET_PAYOUTS_PENDING_APPROVAL_COUNT',
  WIDGET_PAYOUTS_CANCELLATION_REQUESTED_COUNT = 'WIDGET_PAYOUTS_CANCELLATION_REQUESTED_COUNT',

  //Integrations

  WIDGET_ENDPOINTS_COUNT = 'WIDGET_ENDPOINTS_COUNT',
  WIDGET_MAPPINGS_COUNT = 'WIDGET_MAPPINGS_COUNT',

  // Competitions
  READ_COMPETITIONS_ALL_ZONES = 'READ:COMPETITIONS:ALL_ZONES',
  READ_COMPETITIONS_ALL_REGIONS = 'READ:COMPETITIONS:ALL_REGIONS',
  // Messages
  ALLOW_REPORTS_TO_IDENTITY = 'ALLOW_REPORTS_TO_IDENTITY:MESSAGES',
  ALLOW_ALL_SUBORDINATE_IDENTITIES = 'ALLOW_ALL_SUBORDINATE_IDENTITIES:MESSAGES',
  ALLOW_IMMEDIATE_SUBORDINATE_IDENTITIES = 'ALLOW_IMMEDIATE_SUBORDINATE_IDENTITIES:MESSAGES',
  ALLOW_REPORTS_TO_ROLE = 'ALLOW_REPORTS_TO_ROLE:MESSAGES',
  ALLOW_ALL_SUBORDINATE_ROLES = 'ALLOW_ALL_SUBORDINATE_ROLES:MESSAGES',
  ALLOW_IMMEDIATE_SUBORDINATE_ROLES = 'ALLOW_IMMEDIATE_SUBORDINATE_ROLES:MESSAGES',

  // Policies
  DOWNLOAD_PROPOSAL = 'DOWNLOAD_PROPOSAL:POLICIES',

  // Promotions
  PROMOTIONS_VIEW_ANALYTICS = 'READ:VIEW_ANALYTICS:PROMOTIONS',
  PROMOTIONS_EXPORT = 'READ:EXPORT:PROMOTIONS',
  PROMOTIONS_SHILPA_SHAKTHI = 'READ:SHILPA_SHAKTHI:PROMOTIONS',

  // Referrers related permissions
  REFERRERS_VIEW_ANALYTICS = 'READ:VIEW_ANALYTICS:REFERRERS',
  REFERRERS_EXPORT = 'READ:EXPORT:REFERRERS',

  // Leads
  LEADS_CAMPAIGN_SELF_ASSIGNABLE = 'SELF_ASSIGN: LEADS',
  LEADS_CAMPAIGN_OTHER_ASSIGNABLE = 'REASSIGN: LEADS',
  LEADS_MOVE_TO_ASSIGN = 'MOVE_TO_ASSIGN: LEADS',
  LEADS_AGENT_REQUEST_PROCESS = 'AGENT_REQUEST_PROCESS: LEADS',
  LEADS_CAMPAIGNS_VIEW_ALL_IDENTITIES = 'CAMPAIGNS_VIEW_ALL_IDENTITIES: LEADS',
  // Campaigns
  CAMPAIGNS_READ_DATA = 'READ_DATA:CAMPAIGN',
}

export enum PERMISSIONS_TYPES {
  ENTITIES = 'ENTITIES',
  STORAGE_API_KEYS = 'STORAGE_API_KEYS',
  STORAGE = 'STORAGE',
  STORAGE_QUOTA = 'STORAGE_QUOTA',
  USER_QUOTA = 'USER_QUOTA',
  STORAGE_TRASH = 'STORAGE_TRASH',
  TRASH_INFO = 'TRASH_INFO',
  VIEW_ALL_NOTIFICATION = 'VIEW_ALL_NOTIFICATION',
  NOTIFICATIONS = 'NOTIFICATIONS',
  ALL_WIDGET_LAYOUTS = 'ALL_WIDGET_LAYOUTS',
  WIDGET = 'WIDGET',
  INTEGRATIONS = 'INTEGRATIONS',
  SYSTEM = 'SYSTEM',
  IDENTITIES = 'IDENTITIES',
  IDENTITIES_API_KEYS = 'IDENTITIES_API_KEYS',

  // Policies
  DOWNLOAD_PROPOSAL = 'DOWNLOAD_PROPOSAL:POLICIES',

  // Promotions
  PROMOTIONS_VIEW_ANALYTICS = 'READ:VIEW_ANALYTICS:PROMOTIONS',
  PROMOTIONS_EXPORT = 'READ:EXPORT:PROMOTIONS',
  PROMOTIONS_SHILPA_SHAKTHI = 'READ:SHILPA_SHAKTHI:PROMOTIONS',

  // Referrers related permissions
  REFERRERS_VIEW_ANALYTICS = 'READ:VIEW_ANALYTICS:REFERRERS',
  REFERRERS_EXPORT = 'READ:EXPORT:REFERRERS',
}

export enum REFERENCE_PERMISSION_ACTIONS {
  // for the category itself
  READ_CATEGORY = 'READ_CATEGORY',
  WRITE_CATEGORY = 'WRITE_CATEGORY',
  EDIT_CATEGORY = 'EDIT_CATEGORY',
  DELETE_CATEGORY = 'DELETE_CATEGORY',
  RESTORE_CATEGORY = 'RESTORE_CATEGORY',

  // for the items added inside the category
  READ_CATEGORY_ITEMS = 'READ_CATEGORY_ITEMS',
  WRITE_CATEGORY_ITEMS = 'WRITE_CATEGORY_ITEMS',
  APPROVE_CATEGORY_ITEMS = 'APPROVE_CATEGORY_ITEMS',
  EDIT_CATEGORY_ITEMS = 'EDIT_CATEGORY_ITEMS',
  DELETE_CATEGORY_ITEMS = 'DELETE_CATEGORY_ITEMS',
  RESTORE_CATEGORY_ITEMS = 'RESTORE_CATEGORY_ITEMS',
}

export enum INTEGRATION_PERMISSION_ACTIONS {
  //for endpoints
  READ_ENDPOINTS = 'READ:ENDPOINTS',
  WRITE_ENDPOINTS = 'WRITE:ENDPOINTS',
  EDIT_ENDPOINTS = 'EDIT:ENDPOINTS',
  DELETE_ENDPOINTS = 'DELETE:ENDPOINTS',
  RESTORE_ENDPOINTS = 'RESTORE:ENDPOINTS',
  VERIFY_ENDPOINTS = 'VERIFY:ENDPOINTS',

  //for mappings
  READ_MAPPINGS = 'READ:MAPPINGS',
  WRITE_MAPPINGS = 'WRITE:MAPPINGS',
  EDIT_MAPPINGS = 'EDIT:MAPPINGS',
  DELETE_MAPPINGS = 'DELETE:MAPPINGS',
  RESTORE_MAPPINGS = 'RESTORE:MAPPINGS',
  VERIFY_MAPPINGS = 'VERIFY:MAPPINGS',

  //for files
  READ_FILES = 'READ:FILES',
  WRITE_FILES = 'WRITE:FILES',
  EDIT_FILES = 'EDIT:FILES',
  DELETE_FILES = 'DELETE:FILES',
  CONFIGURE_FILES = 'CONFIGURE:FILES',
  APPROVE_FILES = 'APPROVE:FILES',
}

export enum PAYOUTS_PERMISSION_ACTIONS {
  READ_BATCHES = 'READ:BATCHES',
  WRITE_BATCHES = 'WRITE:BATCHES',
  EDIT_BATCHES = 'EDIT:BATCHES',
  DELETE_BATCHES = 'DELETE:BATCHES',

  READ_DEDUCTIONS = 'READ:DEDUCTIONS',
  WRITE_DEDUCTIONS = 'WRITE:DEDUCTIONS',
  EDIT_DEDUCTIONS = 'EDIT:DEDUCTIONS',
  DELETE_DEDUCTIONS = 'DELETE:DEDUCTIONS',

  READ_EARNINGS = 'READ:EARNINGS',
  WRITE_EARNINGS = 'WRITE:EARNINGS',
  EDIT_EARNINGS = 'EDIT:EARNINGS',
  DELETE_EARNINGS = 'DELETE:EARNINGS',

  READ_COMMISSION_BREAKDOWN = 'READ:COMMISSION_BREAKDOWN',
  WRITE_COMMISSION_BREAKDOWN = 'WRITE:COMMISSION_BREAKDOWN',
  EDIT_COMMISSION_BREAKDOWN = 'EDIT:COMMISSION_BREAKDOWN',
  DELETE_COMMISSION_BREAKDOWN = 'DELETE:COMMISSION_BREAKDOWN',

  READ_ENTRIES = 'READ:DATA_ENTRIES',
  WRITE_ENTRIES = 'WRITE:ENTRIES',
  EDIT_ENTRIES = 'EDIT:ENTRIES',
  DELETE_ENTRIES = 'DELETE:ENTRIES',

  READ_BANK_ORDER = 'READ:BANK_ORDER',
  WRITE_BANK_ORDER = 'WRITE:BANK_ORDER',

  VIEW_BREAKDOWN = 'VIEW_BREAKDOWN',
  APPROVE = 'APPROVE',
  REJECT_CANCELLATION = 'REJECT_CANCELLATION',
  APPROVE_CANCELLATION = 'APPROVE_CANCELLATION',
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  APPROVE_REPROCESSING = 'APPROVE_REPROCESSING',
  GENERATE_BANK_ORDER = 'GENERATE_BANK_ORDER',
  PRINT_PAYSLIP = 'PRINT_PAYSLIP',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
  PROCESS_PAYMENT = 'PROCESS_PAYMENT',

  MANUAL_CRON_RUN = 'MANUAL_CRON_RUN',
}

export enum AGENTS_PERMISSION_ACTIONS {
  VIEW_HIERARCHY = 'VIEW_HIERARCHY',
}

export enum RECRUITMENTS_PERMISSION_ACTIONS {
  VIEW_RECRUITED = 'VIEW_RECRUITED',
  VIEW_ALL_DLT = 'VIEW_ALL_DLT',
}

export enum LEADS_PERMISSION_ACTIONS {
  CREATE_CUSTOMER_LEAD = 'CREATE_CUSTOMER_LEAD',
  CREATE_RECRUITMENT_LEAD = 'CREATE_RECRUITMENT_LEAD',
}

export enum ANALYZING_MODES {
  EVERY = 'every',
  SOME = 'some',
  ALLOW_OWN_IDENTITY = 'allowOwnIdentity',
}

export enum PERMISSION_METADATA_KEYS {
  PERMISSIONS = 'permissions',
  ANALYZING_MODE = 'analyzing_mode',
}

export enum ACHIEVEMENT_PERMISSION_ACTIONS {
  CONFIGURE_ACHIEVEMENTS = 'CONFIGURE_ACHIEVEMENTS',
  MANUAL_CRON_RUN = 'MANUAL_CRON_RUN',
  CONFIGURE_LOCK_SCHEDULE = 'CONFIGURE_LOCK_SCHEDULE',
  EXPORT_ACHIEVEMENTS = 'EXPORT',
}

export enum TARGET_PERMISSION_ACTIONS {
  CONFIGURE_LOCK_SCHEDULE = 'CONFIGURE_LOCK_SCHEDULE',
  MANUAL_CRON_RUN = 'MANUAL_CRON_RUN',
  CONFIGURE_TARGETS = 'CONFIGURE',
  EXPORT_TARGETS = 'EXPORT',
}

export enum DEFAULT_ROLES {
  FSA_AGENT = 'FSA Agent',
  AGENT = 'Agent',
  MIS_ADMIN = 'MIS Admin',
}

interface IDefaultQuickActions {
  icon: string;
  title: string;
  link?: string;
  key?: DEFAULT_QUICK_ACTIONS_KEY;
  permissions: string[];
}

export enum DEFAULT_QUICK_ACTIONS_KEY {
  CALL_US = 'call_us',
}

export const DEFAULT_QUICK_ACTIONS: IDefaultQuickActions[] = [
  //{
  //  icon: 'call',
  //  title: 'dashboard.quick.call-us',
  //  key: DEFAULT_QUICK_ACTIONS_KEY.CALL_US,
  //  permissions: []
  //},
];

export const DEFAULT_ROLE_CONFIG = {
  // [DEFAULT_ROLES.IT_ADMIN]: {
  //   is_default: false,
  //   permissions: [],
  // },
};
